import React from 'react';
import { Alert, AlertTitle, Collapse, IconButton, Button, Chip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const compactAlert = {
    mx: 0.5, my: 0.5, py: 0.3, px: 1.5,
    borderRadius: '6px', fontSize: '11px',
    '& .MuiAlert-icon': { fontSize: '16px', py: 0.2, mr: 0.5 },
    '& .MuiAlert-message': { py: 0.2 },
    '& .MuiAlert-action': { pt: 0 },
};

const VatModalAlerts = ({
    t,
    direction,
    hasVatControlAccountEntries,
    code1AdjustmentAmount,
    referenceContinuityIssues,
    showReferenceAlert,
    setShowReferenceAlert,
    viewDocumentDetails,
    beautifyNumber,
}) => {
    const hasRefIssues = referenceContinuityIssues && !referenceContinuityIssues.isContinuous;

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', padding: hasVatControlAccountEntries || hasRefIssues ? '4px 4px 0' : 0 }}>
            {hasVatControlAccountEntries && (
                <Alert severity="info" sx={{ ...compactAlert, flex: '1 1 auto', minWidth: 0 }}>
                    {t('VatReportCode1Code2ExplanationBefore')}
                    <span style={{ color: '#d32f2f', fontWeight: 700 }}>{beautifyNumber(code1AdjustmentAmount)}</span>
                    {t('VatReportCode1Code2ExplanationAfter')}
                </Alert>
            )}

            {hasRefIssues && (
                <>
                    {!showReferenceAlert ? (
                        <Chip
                            icon={<WarningAmberIcon sx={{ fontSize: '14px !important' }} />}
                            label={`${referenceContinuityIssues.issues?.length || 0} ${t('ReferenceContinuityIssues')}`}
                            color="warning"
                            size="small"
                            onClick={() => setShowReferenceAlert(true)}
                            sx={{ cursor: 'pointer', fontWeight: 600, fontSize: '11px', height: '26px' }}
                        />
                    ) : (
                        <Collapse in={showReferenceAlert} sx={{ width: '100%' }}>
                            <Alert
                                severity="warning"
                                sx={{ ...compactAlert }}
                                action={
                                    <IconButton size="small" sx={{ p: 0.3 }} onClick={() => setShowReferenceAlert(false)}>
                                        <CloseIcon sx={{ fontSize: '14px' }} />
                                    </IconButton>
                                }
                            >
                                <AlertTitle sx={{ fontSize: '11px', fontWeight: 700, mb: 0.3 }}>{t('ReferenceContinuityIssues')}</AlertTitle>
                                <div style={{ direction, textAlign: direction === 'rtl' ? 'right' : 'left' }}>
                                    <div style={{
                                        background: '#fff3cd', padding: '4px 6px', borderRadius: '4px',
                                        maxHeight: '80px', overflowY: 'auto', fontSize: '10px', lineHeight: 1.4
                                    }}>
                                        <ul style={{
                                            margin: 0,
                                            paddingRight: direction === 'rtl' ? '14px' : '0',
                                            paddingLeft: direction === 'ltr' ? '14px' : '0'
                                        }}>
                                            {referenceContinuityIssues.issues?.slice(0, 10).map((issue, index) => {
                                                let desc = issue.description;
                                                if (issue.issueType === 'Duplicate') desc = t('Duplicate reference number') + ': ' + issue.actualReference;
                                                else if (issue.issueType === 'Gap') desc = t('Missing reference number') + ': ' + issue.expectedReference;
                                                else if (issue.issueType === 'Invalid') desc = t('Invalid reference format') + ': \'' + issue.actualReference + '\'';
                                                return <li key={index}>{desc}</li>;
                                            })}
                                            {(referenceContinuityIssues.issues?.length || 0) > 10 && (
                                                <li style={{ fontStyle: 'italic' }}>+{referenceContinuityIssues.issues.length - 10} {t('More')}</li>
                                            )}
                                        </ul>
                                    </div>
                                    {viewDocumentDetails && (
                                        <Button
                                            variant="outlined" size="small"
                                            onClick={() => viewDocumentDetails('Incomes')}
                                            sx={{ mt: 0.5, fontSize: '10px', py: 0.2, px: 1, borderRadius: '4px', minHeight: 0 }}
                                        >
                                            {t('ViewIncomes')}
                                        </Button>
                                    )}
                                </div>
                            </Alert>
                        </Collapse>
                    )}
                </>
            )}
        </div>
    );
};

export default VatModalAlerts;
